module.exports = __webpack_public_path__ + "static/media/22770562_1629544970454021_7637515270316657495_o.4246d99f.jpg";